import React from "react";
import img from "../../Images/Tiwi-log.png";

function Faq(props) {
  return (
    <div>
      <div className="container">
        {/* Wrapped the image in an anchor tag */}
        <a href="https://tiwil.app" target="_blank" rel="noopener noreferrer">
          <img src={img} className="mt-4" alt="AStar8 Logo" />
        </a>
        <h1 className="text-center mt-1 faq-heading">
          Frequently Asked Questions
        </h1>

        <div className="mt-5 maindivv">
          <div className="container mt-5 instruction-div">
            <h3>How to Delete Your Account on Tiwil App</h3>
            <ul>
              <li>
                <b>Open the Tiwil Mobile App:</b> Launch the Tiwil application
                on your phone.
              </li>
              <li>
                <b>Log In:</b> Connect your app with Google and Apple account to
                sign in to your account.
              </li>
              <li>
                <b>Go to Your Profile:</b> Tap on the Profile button, usually
                found in the top right corner.
              </li>
              <li>
                <b>Scroll to the Bottom:</b> Once you’re on your Profile Page,
                scroll all the way to the bottom.
              </li>
              <li>
                <b>Close your Account:</b> At the bottom of the Profile Page,
                you’ll find a button labeled "Close your Account". Tap on it.
              </li>
              <li>
                <b>Confirm Deletion:</b> Follow any on-screen instructions or
                confirmations to complete the account deletion process.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;
